import { SEARCH } from './mutation-types'
import contacts from '../contact/contacts-short.json'

export default {
  setUser (state, value) {
    state.user = value
  },
  setUserInfo (state, value) {
    state.userInfo = value
  },
  setUserLang (state, value) {
    state.userInfo.language = value
  },
  setFuelCharge (state, value) {
    state.fuelCharge = value
  },
  clearUser (state) {
    state.user = false
    state.userInfo = false
  },
  initAllContact (state) {
    state.allContacts = contacts
  },
  clearContacts (state) {
    state.allContacts = {}
  },
  [SEARCH.STORE] (state, search) {
    state.search = search
  },
  [SEARCH.STORE_FIELD] (state, search) {
    state.searchFields = search
  },
  [SEARCH.CLEAR] (state) {
    state.search = null
    state.searchFields = {}
    state.searchLastPage = 0
  },
  [SEARCH.SET_LAST_PAGE] (state, page) {
    state.searchLastPage = page
  },
  setAuthorization (state, payload) {
    state.authorization = payload
  }
}
